{
    "UnreturnedCallsFilterSectionTitle": "Filtraggio delle chiamate non restituite",
    "UnreturnedCallsFilterSectionDesc": "Puoi anche controllare quali tipi di chiamate in entrata sono incluse nei report \"Chiamate perse senza risposta\"",
    "UnreturnedCallsFilter_IncludeEscapedLabel": "Includere le chiamate in fuga:",
    "UnreturnedCallsFilter_IncludeDivertedOverflowedLabel": "Includi chiamate deviate\/in overflow a:",
    "UnreturnedCallsFilter_IncludeTransferredLabel": "Includi chiamate trasferite a:",
    "UnreturnedCallsFilter_IncludeAllOtherLabel": "Includi tutte le altre chiamate:",
    "NAME": "UnreturnedCallsFilter"
}